import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { adminApi } from '../lib/adminApi';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  // null = checking, false = signed out, object = signed in
  const [user, setUser] = useState(null);

  useEffect(() => {
    adminApi.get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => adminApi.post('/auth/refresh').then((r) => setUser(r.data)).catch(() => setUser(false)));
    const onOut = () => setUser(false);
    window.addEventListener('admin-logged-out', onOut);
    return () => window.removeEventListener('admin-logged-out', onOut);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.post('/auth/login', { email, password });
    setUser(data);
  }, []);

  const logout = useCallback(async () => {
    await adminApi.post('/auth/logout').catch(() => {});
    setUser(false);
  }, []);

  return <AdminAuthContext.Provider value={{ user, login, logout }}>{children}</AdminAuthContext.Provider>;
};

export const useAdminAuth = () => useContext(AdminAuthContext);

export const RequireAdmin = ({ children }) => {
  const { user } = useAdminAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F4F6F9]" data-testid="admin-auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#14366C]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/dashboard/login" replace state={{ from: location.pathname }} />;
  return children;
};
